import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import BaseArrow from '../icons/Arrow';
import { components, media } from '../../../styles/theme';

const BreakpointMobile = media.largePhone;
const theme = components.mobileSelect;

const Arrow = styled(BaseArrow)`
  z-index: 3;
  position: absolute;
  top: calc(50% - ${theme.arrowSize / 2}px);
  right: 16px;
  pointer-events: none;
`;

const Select = styled.select`
  appearance: none;
  cursor: pointer;

  width: 100%;
  padding: 10px 16px;

  position: relative;

  background-color: ${props =>
    props.active ? theme.backgroundActive : theme.backgroundInactive};
  color: ${props => (props.active ? theme.colorActive : theme.colorInactive)};

  border: none;
  border-radius: 0;

  font-size: 16px;
  font-family: ${props => props.theme.font.sourceSans};
  font-weight: ${props => props.theme.fontWeight.semibold};
`;

const Wrapper = styled.div`
  display: none;
  margin-bottom: 17px;
  position: relative;

  @media ${BreakpointMobile} {
    display: block;
  }
`;

class MobileSelect extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string.isRequired
        })
      )
    ]).isRequired
  };

  constructor(props) {
    super(props);
    const option = props.options.length > 0 ? props.options[0] : { value: '' };
    const selectedValue = typeof option === 'string' ? option : option.value;
    this.state = {
      selectedValue,
      active: false
    };
  }

  handleChange = event => {
    this.setState({ selectedValue: event.target.value }, () =>
      this.props.onChange(this.state.selectedValue)
    );
  };

  handleBlur = event => {
    this.setState({ active: false });
  };

  handleFocus = event => {
    this.setState({ active: true });
  };

  normalizeOptions = () =>
    this.props.options.map(option => {
      if (typeof option === 'string') {
        return { label: option, value: option };
      }
      if (option.label == null) {
        return { label: option.value, value: option.value };
      }
      return option;
    });

  renderOption = option => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  );

  render() {
    const options = this.normalizeOptions();
    const { selectedValue } = this.state;

    return (
      <Wrapper>
        <Arrow
          direction="down"
          fill={this.state.active ? theme.colorActive : theme.colorInactive}
          size={theme.arrowSize}
        />
        <Select
          active={this.state.active}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          value={selectedValue}
        >
          {options.map(this.renderOption)}
        </Select>
      </Wrapper>
    );
  }
}

export default MobileSelect;
